import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * Pluralize a word based on the count
 * @example
 * pluralize('car', 1) => 'car'
 * pluralize('car', 2) => 'cars'
 * pluralize('car', 0) => 'cars'
 * @param {*|string} word The word to pluralize
 * @param {number} count The count to check against
 * @return {*|string}
 */
export const pluralize = (word, count) => {
  if (count === 1) {
    return word;
  }
  return `${word}s`;
};
